import type { TicketList as ListTicketsResponse } from '@rtkwlf/rendall';
import type { InfiniteData } from '@tanstack/react-query';

// See more background of this pattern at
// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

type ListTicketsParam = {
  includeInactive?: boolean;
  after?: Date;
  before?: Date;
  statusFilter?: string;
};

export type TicketListQueryData = InfiniteData<ListTicketsResponse>;

const all = ['tickets'] as const;

// Note these are all paginated

const lists = () => [...all, 'list'] as const;
const listsForOrg = (orgId: string) => [...lists(), orgId] as const;
const list = (orgId: string, params: ListTicketsParam) =>
  [...listsForOrg(orgId), params] as const;

const details = () => [...all, 'detail'] as const;
const detailsForOrg = (orgId: string) => [...details(), orgId] as const;
const detail = (orgId: string, ticketId: string) =>
  [...detailsForOrg(orgId), ticketId] as const;
const events = (orgId: string, ticketId: string, attachmentId: string) =>
  [...detailsForOrg(orgId), ticketId, attachmentId] as const;

export const ticketKeys = {
  all,
  detail,
  details,
  detailsForOrg,
  events,
  list,
  lists,
  listsForOrg,
};
